import React, { Component } from 'react';
import { WidgetHelper } from '../WidgetHelper';

interface IPrimeSuccessWidgetProps {
    isSuccess: boolean;
    dictSuccessText1: string;
    dictSuccessText2: string;
    dictSuccessContact1: string;
    dictSuccessContact2: string;
    dictSuccessPhone: string;
    dictSuccessSignature1: string;
    dictSuccessSignature2: string;
    dictFailLabel: string;
}

type IPrimeSuccessWidgetState = object;

export class PrimeSuccessWidget extends Component<
    IPrimeSuccessWidgetProps,
    IPrimeSuccessWidgetState
> {
    constructor(props: IPrimeSuccessWidgetProps) {
        super(props);
        this.state = {};
    }

    render() {
        const borderRadius = {
            borderRadius: '100%',
        } as React.CSSProperties;
        const borderRadiusBig = {
            borderRadius: '100%',
            fontSize: '150%',
        } as React.CSSProperties;

        const phoneLink = 'tel:' + this.props.dictSuccessPhone;
        //const mailLink = "mailto:" + this.props.dictSuccessMail + "?subject=Prime Phoenix/n";

        if (this.props.isSuccess) {
            return (
                <div className="container mb-5">
                    <div className="row mb-4">
                        <div className="offset-5 col-2 text-center">
                            <i
                                className="icon-check alert-success p-3"
                                style={borderRadius}
                            ></i>
                        </div>
                    </div>
                    <div className="row">
                        <div className="offset-3 col-6 text-center">
                            {this.props.dictSuccessText1}
                        </div>
                    </div>
                    <div className="row mb-3">
                        <div
                            className="offset-3 col-6 text-center"
                            dangerouslySetInnerHTML={{
                                __html: this.props.dictSuccessText2,
                            }}
                        ></div>
                    </div>
                    <div className="row mb-5">
                        <div className="offset-3 col-6 text-center">
                            {this.props.dictSuccessContact1}{' '}
                            <a href={phoneLink}>
                                {this.props.dictSuccessPhone}
                            </a>{' '}
                            {this.props.dictSuccessContact2}.
                        </div>
                    </div>
                    <div className="row">
                        <div className="offset-3 col-6 text-center">
                            {this.props.dictSuccessSignature1}
                            <br />
                            <strong>{this.props.dictSuccessSignature2} </strong>
                        </div>
                    </div>
                </div>
            );
        } else {
            return (
                <div className="container">
                    <div className="row mb-4">
                        <div className="offset-5 col-2 text-center">
                            <i
                                className="icon-warning alert-danger p-3"
                                style={borderRadiusBig}
                            ></i>
                        </div>
                    </div>
                    <div className="row mb-3">
                        <div className="offset-3 col-6 text-center">
                            {this.props.dictFailLabel}
                        </div>
                    </div>
                </div>
            );
        }
    }
}

WidgetHelper.register(PrimeSuccessWidget, 'prime-success-widget');
